module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-percent/spk-percent.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-percent/spk-percent.component.scss
// module chunks = main